import Reflux from 'reflux';

const LookupTableDataAdaptersActions = Reflux.createActions({
  searchPaginated: { asyncResult: true },
  reloadPage: { asyncResult: true },
  get: { asyncResult: true },
  create: { asyncResult: true },
  delete: { asyncResult: true },
  update: { asyncResult: true },
  getTypes: { asyncResult: true },
  lookup: { asyncResult: true },
  validate: { asyncResult: true },
});

export default LookupTableDataAdaptersActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/actions/lookup-tables/LookupTableDataAdaptersActions.js